module.exports = __webpack_public_path__ + "img/ico-scroll-left.cbc46838.svg";